import { useEffect, useState } from 'react'
import { CodemaxBrand } from '@/components/Brand'
import { Button } from '@/components/ui/primitives'
import * as session from '@/lib/session'

/**
 * Where ARMS returns to after ending the session. Registered on the portal client as a
 * post-logout redirect URI.
 *
 * A separate screen rather than a redirect back to sign-in, because landing on a sign-in
 * page immediately after pressing Sign out reads as a failed sign-out, and people press
 * it again. Unless the sign-out was somebody changing account, which is the opposite
 * case: they asked to sign in as somebody else, so stopping here is the failure.
 */
export function SignedOut() {
  const [switching] = useState(() => session.takeSwitchRequest())

  useEffect(() => {
    if (switching) void session.signIn('/')
  }, [switching])

  return (
    <div className="grid min-h-full place-items-center px-6 py-16">
      <div className="w-full max-w-sm text-center">
        <CodemaxBrand className="mx-auto h-7" />

        <h1 className="mt-8 text-2xl font-semibold tracking-[-0.02em]">Signed out</h1>

        {switching ? (
          <p className="mt-1 text-[13px] text-muted">
            Taking you back to Codemax to sign in again.
          </p>
        ) : (
          <>
            <p className="mt-1 text-[13px] text-muted">
              Your Codemax session has ended on this browser.
            </p>

            <Button
              variant="primary"
              className="mt-7 w-full"
              onClick={() => window.location.assign('/')}
            >
              Sign in again
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
